import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { colors } from '@/styles/colors';

interface ErrorMessageProps {
  message: string | null;
  visible?: boolean;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, visible = true }) => {
  if (!message || !visible) {
    return null;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.text}>{message}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.errorBg,
    borderRadius: 8,
    padding: 12,
    paddingHorizontal: 36,
    marginTop: 8,
    marginBottom: 16,
  },
  text: {
    color: colors.error,
    fontSize: 14,
    textAlign: 'center',
  },
});
